import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
 
// NEW — remove the SEO fallback content as soon as React takes over
const seoFallback = document.getElementById('seo-fallback');
if (seoFallback) seoFallback.remove();
// NEW end
 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4500,
            style: {
              background: '#1c1c1c',
              color: '#f8f5ef',
              border: '1px solid rgba(245,168,0,0.28)',
              // matches --radius; toasts were the last square corners left
              borderRadius: '6px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
              fontSize: '0.82rem',
              padding: '0.85rem 1rem',
              fontFamily: 'var(--font-sans)',
            },
            success: { iconTheme: { primary: '#F5A800', secondary: '#141414' } },
            error: { iconTheme: { primary: '#f87171', secondary: '#141414' } },
          }}
        />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
 
// Only register the service worker in production — registering it during
// `npm start` fights with webpack's hot-reload client and causes repeated
// reload/fetch loops (was hammering /api/banners/all and hitting the rate limiter).
if (process.env.NODE_ENV === 'production') {
  serviceWorkerRegistration.register({
    onSuccess: () => console.log('[PWA] App cached for offline use OK'),
    onUpdate: () => console.log('[PWA] New version available'),
  });
} else {
  serviceWorkerRegistration.unregister();
}
